import { FC } from "react";
import { AppPartType } from "../../../types";
import { InboxOutlined, PaperClipOutlined } from "@ant-design/icons";
import { notification, Upload } from "antd";
type Date = {
  appPart: AppPartType;
};
const Attachment: FC<Date> = ({ appPart: { default_value } }) => {
  return (
    <div
      className="attachment-container"
      style={{
        justifyContent: "flex-end",
      }}
    >
      <Upload.Dragger name="files" multiple={true} disabled={true}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              width: 40,
              height: 40,
              fontSize: 30,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderLeft: "1px dashed #d9d9d9",
            }}
          >
            <PaperClipOutlined />
          </div>
        </div>
      </Upload.Dragger>
    </div>
  );
};

export default Attachment;
